<template>
  <div class="column is-four-fifth course">
    <h4 class="title is-4">Instruktör</h4>
    <section class="modal-card-body">
      <div class="field">
        <label class="label">Förnamn</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Förnamn"
            v-model="instructor.first_name"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Efternamn</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Efternamn"
            v-model="instructor.last_name"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Mailadress</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Mailadress"
            v-model="instructor.email"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Telefonnummer</label>
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder="Telefonnummer"
            v-model="instructor.phone_number"
          />
        </div>
      </div>
    </section>

    <div class="buttons">
      <a class="button is-danger" @click="deleteInstructor">Radera instruktör</a>
      <a class="button is-primary" @click="updateInstructor">Updatera instruktör</a>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "Instructor",
  props: {
    instructor: Object,
  },
  methods: {
    deleteInstructor() {
      if (confirm("Vill du verkligen radera isntrtuktören?")) {
        axios
          .delete("/api/instructors/" + this.instructor._id + "/")
          .then(() => {
            this.$emit("reloadInstructors");
          });
      }
    },
    updateInstructor() {
      axios
        .put("/api/instructors/" + this.instructor._id + "/", this.instructor)
        .then(() => {
          this.$emit("reloadInstructors");
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info {
  text-align: left;
}

#copyMail {
  position: absolute;
  top: -200px;
}

.course {
  text-align: left;
}

.fas {
  margin-right: 15px;
}

.input {
  max-width: 30em;
}

</style>